import {Vue} from 'ui.vue';
import {useEmptyMount} from 'itrkomi.vue.use';
import {candidateReIndexing} from 'itrkomi.vue.candidates_reindexing';
Vue.use(useEmptyMount);
Vue.create({
    components: {
        candidateReIndexing,
    },
    data:{
        startReIndex:false,
    },
    mounted(){
        Vue.event.$on('reindex-candidates',()=>{
            this.startReIndex = true;
        })
    },
    template:`<div>
                <candidateReIndexing v-model="startReIndex"/>
            </div>`,

}).$emptyMount();